"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XmlNode_1 = require("../JSONImpl/XmlNode");
var StringBuilder_1 = require("../../Utils/StringBuilder");
var TextUtils_1 = require("../../Utils/TextUtils");
var XmlAttributes_1 = require("../JSONImpl/XmlAttributes");
var SaxDocument = /** @class */ (function () {
    function SaxDocument() {
        this.xml = require("sax-parser");
        this.parser = new this.xml.SaxParser(function (cb) {
            var lastNode;
            //let rootNode: XmlNode;
            var sText;
            cb.onStartDocument(function () { });
            cb.onEndDocument(function () { });
            cb.onStartElementNS(function (localName, attrs, prefix, uri, namespaces) {
                var bIndex = false;
                var bFirstNode = (lastNode == null);
                var attributes = new XmlAttributes_1.default(attrs);
                if (attributes.getIndex("ext-file") >= 0) {
                    //lastNode = getIncludeNode(localName, attributes.getValue(attributes.getIndex("ext-file")));
                }
                else {
                    bIndex = attributes && attributes.length > 0 && !TextUtils_1.default.isEmpty(attributes.getValue("name"));
                    if (bIndex) {
                        lastNode = new XmlNode_1.default(lastNode, localName, attributes, "name", attributes.getValue("name"));
                    }
                    else {
                        lastNode = new XmlNode_1.default(lastNode, localName, attributes);
                    }
                }
                if (bFirstNode) {
                    this.rootNode = lastNode;
                }
                sText = new StringBuilder_1.default();
            });
            cb.onEndElementNS(function (elem, prefix, uri) {
                if (sText != null) {
                    lastNode.setText(sText.toString());
                    sText = null;
                }
                lastNode = lastNode.getParentNode();
            });
            cb.onCharacters(function (chars) {
                // if (sText.indexOf("Contrase") > 0) {
                //     sText = sText.replace("&gt;", ">");
                // }
                if (sText != null) {
                    sText.append(chars);
                }
            });
            cb.onCdata(function (cdata) {
                console.log("<CDATA>" + cdata + "</CDATA>");
            });
            cb.onComment(function (msg) {
                //console.log("<COMMENT>" + msg + "</COMMENT>");
            });
            cb.onWarning(function (msg) {
                console.log("<WARNING>" + msg + "</WARNING>");
            });
            cb.onError(function (msg) {
                console.log("<ERROR>" + JSON.stringify(msg) + "</ERROR>");
            });
        });
    }
    // private lastNode: XmlNode;
    // private rootNode: XmlNode;
    // private sText: StringBuilder;
    SaxDocument.prototype.Deserialize = function (context, sPath, Source, useTranslation) {
        var _a, _b;
        this.parser.parseString(Source);
        if ((_b = (_a = this.parser) === null || _a === void 0 ? void 0 : _a.m_hndDoc) === null || _b === void 0 ? void 0 : _b.rootNode) {
            this.m_rootNode = this.parser.m_hndDoc.rootNode;
        }
    };
    SaxDocument.prototype.getRootNode = function () {
        return this.m_rootNode;
    };
    SaxDocument.prototype.createNode = function (node, strName) {
        throw new Error("Method not implemented.");
    };
    return SaxDocument;
}());
exports.default = SaxDocument;

//# sourceMappingURL=SaxDocument.js.map
